import RegistrationForm from './RegistrationForm.vue';

export default RegistrationForm;
